// es7 snippet rfce

import React, { forwardRef } from 'react'
import { CardContent, Typography, Card } from '@material-ui/core'
import './Message.css';

const Message = forwardRef(({ message, username }, ref) => {
    const isUser = username === message.username;

    return (
        <div ref={ref} className={`message ${isUser && `message__user`}`}>
            <Card className={isUser ? "message__userCard" : "message__guestCard"}>
                <CardContent>
                    <Typography color="white" variant="h6" component="h4">
                        {!isUser && `${message.username || 'Unknown User'}: `}  {message.message}
                    </Typography>
                </CardContent>
            </Card>
        </div>

        // <div>
        //     <h2>
        //         {props.username}: {props.text}
        //     </h2>

        // </div>
    )
})

export default Message
